<template>
  <div id="footer"  v-if="isMaxScreen">
     <!-- 底部模块 -->
    <div class="footer-box">
      <div class="top">
        <div class="left">
            <!-- <img class="logo" src="@/assets/img/logo.png" alt=""> -->
            <div class="list-box">
              <div class="list">广西信息职业技术学院招生与就业处</div>
              <div class="list">招生热线：0771-2205522，2205533</div>
              <div class="list">邮政编码：530200</div>
              <div class="list">学校地址：广西南宁市邕宁区步云路31号</div>
            </div>
        </div>
        <div class="right">
            <div class="ewm-box">
              <img class="ewm" src="@/assets/img_pc/footer1.png" alt="">
              <div class="name">招生小程序</div>
            </div>
            <div class="ewm-box">
              <img class="ewm" src="@/assets/img_pc/footer2.png" alt="">
              <div class="name">官方微信公众号</div>
            </div>
        </div>
      </div>
    </div>
    <div class="bottom">
       <div>本网站由广西信息职业技术学院委托校派教育科技有限公司运行管理</div>
       <div>Copyright © 2022 oe.schoolpi.net All Rights Reserved ICP备：皖B2-20190136-2增值电信业务经营许可证 皖B2-20190136网络文化经营许可证皖网文【2019】3757-155号</div>
        <div>---------- Admissions Office ----------</div>
    </div>
      <!-- 底部模块 -->
  </div>
   <FooterH5 v-else />
</template>

<script>
import FooterH5 from '@/components/Main/main_h5/footer_h5'
export default {
  name: 'Footer',
  data () {
    return {
      isMaxScreen: true
    }
  },
  components: { FooterH5 },
  watch: {},
  mounted () {
    this.isMaxScreen = document.body.clientWidth > 850
    window.addEventListener('resize', () => {
      this.isMaxScreen = document.body.clientWidth > 850
    })
  }
}
</script>

<style scoped lang="scss">
#footer {
  width: 100%;
  color: #FFFFFF;
  font-size: 16px;

  .footer-box{
    padding: 44px 0 78px;
    width: 100%;
    background: #4E55AF;
    .top{
      display: flex;
      justify-content: space-between;
      width: 1200px;
      margin: 0 auto;
    .left{
      display: flex;
      width: 58%;
      flex-direction: column;
      align-items: left;
      margin-left: 20px;
      .logo{
        width: 222px;
        height: 82px;
        margin-bottom: 14px;
      }

      .list-box{
        position: relative;

        font-size: 16px;

        .list{
          font-weight: 400;
          margin-bottom: 12px;
        }
        .list:first-child {
          font-size: 20px;
          margin-bottom: 24px;
        }
      }
    }
    .right{
      display: flex;
      .ewm-box{
        margin-left: 42px;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 16px;
        .ewm{
          width: 96px;
          height: 96px;
          margin-bottom: 12px;
          }
        }
      }
    }

  }
  .bottom{
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF;
    background: #31378E;
    text-align: center;
    padding: 24px 0;
    div:nth-last-child(2) {
       margin: 10px 0;
    }
  }
}

</style>
